module.exports = __webpack_public_path__ + "img/vi_vn.2e1215e6.png";